module.exports = __webpack_public_path__ + "static/media/crossIcon.8a7c3f0d.svg";